import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceShell } from "../../../../features/workspace/index.ts";
import { BillDetailPage } from "../../../../features/bills/detail/index.ts";
import "../../../../features/bills/detail/bill-detail.css";

export const Route = createFileRoute("/(workspace)/procurement/bills/$billId/")({
  component: BillDetailRoute,
});

function BillDetailRoute() {
  const { billId } = Route.useParams();
  return (
    <WorkspaceShell
      breadcrumbs={[{ label: "Procurement" }, { label: "Bills", to: "/procurement/bills" }, { label: "Detail" }]}
      // Detail pages render their own full-width composer-head + composer-foot
      // and constrain only the middle content to a max-width — see
      // `bill-detail.css` `.detail-main` rules. Strip the shell's default
      // padding + max-width so the sticky bands span the viewport.
      viewportClassName="p-0 md:p-0"
      contentClassName="max-w-none"
    >
      <BillDetailPage billId={billId} />
    </WorkspaceShell>
  );
}
